import {
  AgentType,
  hasEditLifecycleCapability,
  type AgentLifecycleTagSource,
} from "@superblocksteam/shared";

/**
 * Shown on disabled Provision / Retry controls when no agent has advertised
 * App Databases lifecycle. Same copy on every surface so they cannot disagree.
 */
export const APP_DATABASES_AGENT_SETUP_TOOLTIP =
  "App Databases must be enabled on a connected On-Premise Agent.";

/**
 * Product visibility gate for Admin App Databases (nav and route).
 * Flag plus topology: cloud-prem, or a SaaS ONPREMISE org. Does not require
 * a lifecycle-capable agent; that only enables dispatching work.
 */
export function isManagedNativeDatabasesAvailable({
  managedNativeDbEnabled,
  organization,
  isCloudPrem = false,
}: {
  managedNativeDbEnabled: boolean;
  organization?: { agentType?: AgentType } | null;
  isCloudPrem?: boolean;
}): boolean {
  if (!managedNativeDbEnabled) {
    return false;
  }
  if (isCloudPrem) {
    return true;
  }
  return organization?.agentType === AgentType.ONPREMISE;
}

/**
 * Whether any connected agent could claim App Databases work (provision,
 * retry). Cloud-prem has no OPA lifecycle tags; the rollout flag is the
 * deployment opt-in and dispatch stays allowed.
 */
export function canDispatchManagedNativeDbWork({
  agents,
  isCloudPrem = false,
}: {
  agents?: readonly AgentLifecycleTagSource[];
  isCloudPrem?: boolean;
}): boolean {
  if (isCloudPrem) {
    return true;
  }
  return hasEditLifecycleCapability(agents);
}
